import _ from 'lodash';
import moment from 'moment';

import { ApiMixin } from "./ApiMixin";
import { HolidayApi } from '../../util/api/HolidayApi';

import { Alert } from "../Alert";

//Creates an object to represent the employer, with some helper functions
class Holiday {
    id : "";
    
    holidayBegin : null;
    holidayEnd : null;

    holidayName : "";
    note : ""


    constructor(holiday = {}, shouldParseValues = false) {
        //Adds any default values passed by the developer 
        _.defaults(this, holiday);
    }

    get holidayBeginObject() {
        return moment(this.holidayBegin);
    }
    get holidayEndObject() {
        return moment(this.holidayEnd)
    }

    mutate(holiday = {}) {

        //This takes all matching keys from the holiday and assigns them to this object

        _.assign(this, _.pick(holiday, _.keys(this)));

    }


    //Saves/updates object to the api, shows errors or updates state. 
    async save(appStore) {

        const api = ApiMixin(HolidayApi);

        let response = await api.save(this);

        //If there are errors, we iterate over them and display them.
        //Then we return false, in case the parent needs to know we failed.
        if (response.errors.length > 0) {
            _.forEach(response.errors, (error) => {
                appStore.addAlert(error);
            });

            return response;
        }

        let newHolidayObject;

        if (this.id) {

            let holidayObject = appStore.holidays.getById(this.id);

            //Diff any changes between store and response.
            holidayObject.mutate(this);

            newHolidayObject = holidayObject;
        }
        //If not, we're going to save it to the API, and to push it to the store
        else {

            newHolidayObject = new Holiday(response.data);

            //appStore.addItem({ type: "holiday", data: newHolidayObject });
        }

        //Success alert
        let successAlert = new Alert("Successfully saved", "Successfully saved holiday.", "sucess");
        appStore.addAlert(successAlert);


        //Return the new timesheet object  
        return newHolidayObject;
    }

}

export default Holiday;